export const FETCH_APPLICATION_DATA_SUCCESS = 'FETCH_APPLICATION_DATA_SUCCESS';
export const FETCH_APPLICATION_DATA_FAILURE = 'FETCH_APPLICATION_DATA_FAILURE';
export const STORE_APP_DATA_URLS = 'STORE_APP_DATA_URLS';
export const SHOW_MODAL = 'SHOW_MODAL';
export const SHOW_LOADER = 'SHOW_LOADER';
export const STORE_LANGUAGE_CODE = 'STORE_LANGUAGE_CODE';
